import React from 'react';
import {
  Card,
  IconBox,
  LeftSide,
  StatusBadge,
  StatusDot,
  StatusText,
  Time,
  Title,
  TopRow,
} from 'features/hive/ui/HiveBody/SensorCard/styles.ts';
import {COLORS} from 'shared/consts';
import {useHivesStore} from "entities/hives";

export type SensorStatus = 'normal' | 'warning' | 'danger';

type Props = {
  icon?: React.ReactNode;
  title: string;
  time?: string;
  statusText: string;
  statusColor?: string;
  statusBg?: string;
  status: SensorStatus;
};

export const SensorCard: React.FC<Props> = ({icon, title, time, statusText, status}) => {
  const setLocationModalOpen = useHivesStore((s) => s.setLocationModalOpen);
  const statusColor =
    status === 'normal'
      ? COLORS.SUCCESS.DEFAULT
      : status === 'warning'
        ? COLORS.WARNING.ON_CONTAINER
        : COLORS.ERROR.ON_CONTAINER;
  const statusBg =
    status === 'normal'
      ? COLORS.SUCCESS.CONTAINER_DEFAULT
      : status === 'warning'
        ? COLORS.WARNING.CONTAINER_DEFAULT
        : COLORS.ERROR.CONTAINER_DEFAULT;
  
  if (title === 'Геопозиция') {
    return (
      <Card>
        <TopRow>
          <LeftSide>
            {icon && <IconBox>{icon}</IconBox>}
            <Title>{title}</Title>
          </LeftSide>
          
          {time && <Time>{time}</Time>}
        </TopRow>
        
        <StatusBadge style={{background: statusBg, cursor: 'pointer'}} onClick={() => setLocationModalOpen(true)}>
          <StatusDot style={{background: statusColor}} />
          <StatusText style={{color: statusColor}}>{statusText}</StatusText>
        </StatusBadge>
      </Card>
    )
  }

  return (
    <Card>
      <TopRow>
        <LeftSide>
          {icon && <IconBox>{icon}</IconBox>}
          <Title>{title}</Title>
        </LeftSide>

        {time && <Time>{time}</Time>}
      </TopRow>

      <StatusBadge style={{background: statusBg}}>
        <StatusDot style={{background: statusColor}} />
        <StatusText style={{color: statusColor}}>{statusText}</StatusText>
      </StatusBadge>
    </Card>
  );
};
